/* eslint-disable camelcase */
import { steamConstants } from '../constants'
import { steamService } from '../../services'
import { request, success, failure } from './helper'
import { getCaptchaToken } from '../../utilities/googleCaptcha.util'

function saveAuthUser(payload) {
  const { steamid, access_token } = JSON.parse(payload)
  return dispatch => {
    dispatch(success(steamConstants.SAVE_AUTH_USER, { steamid, accessToken: access_token }))
  }
}

function removeAuthUser() {
  return dispatch => {
    steamService.removeUserTicket()
    return dispatch(success(steamConstants.REMOVE_AUTH_USER))
  }
}

function checkAuthenticated(user) {
  return async dispatch => {
    try {
      const localStorage = steamService.getUserTicket()
      if (!localStorage || !localStorage.steamid || !localStorage.access_token) {
        throw new Error('No localStorage')
      }

      const userId = user.currentUser.id
      const resp = await steamService.verifyUserSteamTicket({ ...localStorage, userId })

      return dispatch(success(steamConstants.STEAM_CHECK_AUTHENTICATE_SUCCESS, resp))
    } catch (error) {
      const errorMessage = error?.message || error?.toString() || 'Unknown error'
      dispatch(failure(steamConstants.STEAM_CHECK_AUTHENTICATE_FAILURE, errorMessage))
      throw error
    }
  }
}

function activateGame(userId, contentId, couponCode, steamid, accessToken) {
  return async dispatch => {
    dispatch(request(steamConstants.STEAM_ACTIVATE_GAME_REQUEST))
    try {
      const localStorage = steamService.getUserTicket()

      if (steamid !== localStorage.steamid || accessToken !== localStorage.access_token) {
        dispatch(failure(steamConstants.STEAM_ACTIVATE_GAME_FAILURE, 'Invalid values'))
        throw new Error()
      }

      const steamResponse = await steamService.activateGame(
        steamid,
        accessToken,
        userId,
        contentId,
        couponCode
      )
      const { response, key_registered: keyRegistered } = steamResponse

      if (keyRegistered) {
        dispatch(success(steamConstants.STEAM_ACTIVATE_GAME_SUCCESS, response))
      } else {
        dispatch(failure(steamConstants.STEAM_ACTIVATE_GAME_FAILURE, response))
      }
    } catch (error) {
      removeAuthUser()
      const errorMessage = error?.message || error?.toString() || 'Unknown error'
      dispatch(failure(steamConstants.STEAM_ACTIVATE_GAME_FAILURE, errorMessage))
      throw error
    }
  }
}

// Save Steam USer's ticket
function saveParsedHash(payload) {
  return async dispatch => {
    try {
      const { access_token, steamid } = payload
      if (!access_token || !steamid) throw new Error() // TODO: Add an error message

      const steam_v1 = JSON.stringify({ access_token, steamid })
      steamService.saveUserTicket(steam_v1)

      return dispatch(success(steamConstants.SAVE_USER_TICKET_SUCCESS, { access_token, steamid }))
    } catch (err) {
      const errorMessage = err?.message || err?.toString() || 'Unknown error'
      return dispatch(failure(steamConstants.SAVE_USER_TICKET_FAILURE, errorMessage))
    }
  }
}

const integrationCheck =
  ({ steamid, access_token: accessToken }, user) =>
  async dispatch => {
    dispatch(request(steamConstants.USER_LOGIN_REQUEST))
    try {
      if (!steamid || !accessToken) throw new Error() // TODO: Add an error message

      const captchaToken = await getCaptchaToken('steam_redirect')
      await steamService.userSteamCheck(user, steamid, accessToken, captchaToken)
      return dispatch(success(steamConstants.USER_LOGIN_SUCCESS))
    } catch (err) {
      const errorMessage = err?.message || err?.toString() || 'Unknown error'
      dispatch(request(steamConstants.USER_LOGIN_FAILURE, errorMessage))
      throw err
    }
  }

export default {
  activateGame,
  checkAuthenticated,
  integrationCheck,
  removeAuthUser,
  saveAuthUser,
  saveParsedHash,
}
